import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Tooltip } from "bootstrap";

import "./index.scss"
import { useEffect } from "react";

const Landing = () => {

    const { auth } = useAuth();
    const navigate = useNavigate();
    
    const navEl = document.querySelector(".navbar");
    if (navEl) {
        window.addEventListener("scroll", () => {
            if (window.scrollY >= 56) {
                navEl.classList.add("ewp-navbar-scroll");
            } else {
                navEl.classList.remove("ewp-navbar-scroll");
            }
        });
    }
    
    useEffect(() => {
        // check if user has auth token then redirect to /home
        if (localStorage.getItem("token")) {
            console.log("redirecting to home")
            navigate("/home", { replace: true });
        }
        else {
            // Load the SVG map dynamically
            fetch("landing/assets/europe-map-tooltip.svg")
            .then((response) => response.text())
            .then((svg) => {
                document.getElementById("map-container").innerHTML = svg;
                // Initialize Bootstrap tooltips
                const tooltipTriggerList = document.querySelectorAll(
                    '[data-bs-toggle="tooltip"]'
                );
                tooltipTriggerList.forEach((el) => new Tooltip(el));
            })
            .catch((err) => console.error("Error loading SVG map:", err));
        }
    }, []);
    
    // render nothing if token exists 
    if (localStorage.getItem("token")) {
        return (<></>);
    }
    return (
        <>
            <header>
                <nav className="container-fluid navbar fixed-top">
                    <div className="container-fluid">
                        <a
                            className="navbar-brand"
                            href="#"
                        >
                            <img
                                src="landing/assets/EWP-Dashboard-logo.png"
                                alt="EWP Dashboard Logo"
                                width="150"
                                height=""
                                className="d-inline-block align-text-top"
                            />
                        </a>
                        <a
                            className="navbar-brand"
                            href="/login"
                            ><button
                                type="button"
                                className="ewp-yellow-bg px-4 py-2 rounded-4 ewp-button border-0"
                            >
                                Log in
                            </button></a
                        >
                    </div>
                </nav>
            </header>
            <main>
                <img
                    className="ewp-bg-image"
                    src="landing/assets/EWP-Dashboard-Header.jpg"
                    alt="Background image"
                />
                <div className="container-fluid ewp-header-container">
                    <div className="row ewp-header">
                        <div className="align-middle my-auto ewp-header-align">
                            <div className="container-fluid px-0 mx-0">
                                <h1 className="ewp-h1 fw-bold text-center text-light">EWP Dashboard</h1>
                                <hr className="ewp-line" />
                                <h2 className="text-light text-center ewp-simplicity">
                                    Smart simplicity
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row ewp-magenta-bg ewp-1_1em d-flex">
                        <div className="col d-flex align-items-center justify-content-center p-1">
                            <p className="ewp-p text-light text-center my-1">
                                New major update just released!
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container-fluid m-0 ewp-light-blue-bg gx-0 py-5">

                    <div className="row d-flex justify-content-center px-0 pt-2 mx-0">
                        <div
                            className="row row-cols-md-4 row-cols-sm-2 text-center col-lg-9 col-md mx-0 px-0"
                        >
                            <div className="col mb-4">
                                <div className="card ewp-card rounded-4 h-100">
                                    <div className="card-body">
                                        <img
                                            src="landing/assets/arrows.svg"
                                            onError={(e) => {e.onerror=null; e.src='landing/assets/arrows.png';}}
                                            className="card-img-top ewp-icon"
                                            alt="arrows icon"
                                        />

                                        <h6 className="ewp-h6 card-text ewp-text-blue">
                                            Inter-Institutional Agreements
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col mb-4">
                                <div className="card ewp-card rounded-4 h-100">
                                    <div className="card-body">
                                        <img
                                            src="landing/assets/people.svg"
                                            onError={(e) => {e.onerror=null; e.src='landing/assets/people.png';}}
                                            className="card-img-top ewp-icon"
                                            alt="people icon"
                                        />
                                        <h6 className="ewp-h6 card-text ewp-text-blue">Nominations</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col mb-4">
                                <div className="card ewp-card rounded-4 h-100">
                                    <div className="card-body">
                                        <img
                                            src="landing/assets/padlock.svg"
                                            onError={(e) => {e.onerror=null; e.src='landing/assets/padlock.png';}}
                                            className="card-img-top ewp-icon"
                                            alt="padlock icon"
                                        />
                                        <h6 className="ewp-h6 card-text ewp-text-blue">
                                            Online Learning Agreements
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col mb-4">
                                <div className="card ewp-card rounded-4 h-100">
                                    <div className="card-body">
                                        <img
                                            src="landing/assets/medal.svg"
                                            onError={(e) => {e.onerror=null; e.src='landing/assets/medal.png';}}
                                            className="card-img-top ewp-icon"
                                            alt="medal icon"
                                        />
                                        <h6 className="ewp-h6 card-text ewp-text-blue">
                                            Transcripts of Records
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container justify-content-center d-flex">
                        <div
                            className="row mt-4 d-flex justify-content-center ewp-top-performance"
                        >
                            <div
                                className="col-xxl-5 col-xl-6 col-lg-7 col-md-8 col-sm-12 py-4 px-0 text-center"
                            >
                                <p className="ewp-p ewp-text-larger">
                                    The EWP Dashboard is the <strong>gold standard</strong> for EWP
                                    connectivity and famous for its
                                    <strong> bullet proof reliability</strong>. It&nbsp;has earned
                                    the trust of <strong> more than 2700</strong> higher education
                                    institutions and is funded by the
                                    <strong> European Commission</strong>.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

                <section className="ewp-map-section position-relative">
                    <div className="container-fluid">
                        <div
                            className="row align-items-center flex-column flex-md-row d-flex justify-content-between"
                        >
                            <div
                                className="ewp-map-text-column col-lg-4 col-md-6 col-sm-8 text-md-start p-0 rounded-4"
                            >
                                <h3 className="ewp-h3 ewp-text-magenta pb-2">Powered by Europe</h3>
                                <p className="col-lg-9 ewp-p ewp-text-larger m-0 lh-lg">
                                    The <strong className="ewp-text-magenta">EWP Dashboard</strong> is
                                    used by the majority of institutions in
                                    <strong className="ewp-text-magenta"> 31 countries</strong> across
                                    Europe.*
                                </p>
                            </div>

                            <div className="col p-0">
                                <div className="map-wrapper">
                                    <div id="map-container"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="container justify-content-center d-flex">
                    <div className="row d-md-flex justify-content-center ewp-top-performance">
                        <div
                            className="mx-sm-auto col-xxl-6 col-xl-7 col-lg-8 col-md-9 col-sm-10 text-center ewp-light-blue-bg p-4 p-md-5 my-5 rounded-4"
                        >
                            <h4 className="ewp-h4 ewp-text-blue mb-4">
                                Europe's top performers <br />use EWP Dashboard!
                            </h4>
                            <p className="ewp-p ewp-text-larger mb-0">
                                Of the 220 universities in the first 6 countries that met the EC's
                                95% digital Learning Agreement goal, 217 use the EWP Dashboard.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="ewp-light-blue-bg">
                <div className="container justify-content-center py-5 mt-3 mt-lg-5">
                    <div
                        className="row d-flex justify-content-center px-5 ewp-container-maxwidth"
                    >
                        <div className="col-12 px-0 pe-md-3 pe-lg-5 py-3 my-3 my-md-4 my-lg-4">
                            <h3
                                className="ewp-h3 ewp-text-blue mb-3 mb-md-3 mb-lg-5 text-start text-md-start text-lg-center"
                            >
                                Why choose EWP Dashboard
                            </h3>
                        </div>
                    </div>
                    <div
                        className="row d-flex justify-content-center px-5 ewp-container-maxwidth"
                    >
                        <div className="col-sm-12 col-md-4 col-lg-3 px-0 pe-md-3 pe-lg-5">
                            <h4 className="ewp-h4 ewp-text-magenta mb-3 mb-md-3 mb-lg-5">
                                Rock solid and ready to rock
                            </h4>
                            <p className="ewp-p ewp-text-larger">
                                We power European student mobility. No hiccups, no excuses, and no
                                surprises - you know you can count on us to help you get your job
                                done anytime, anywhere.
                            </p>
                            <a href="/register"
                                ><button
                                    type="button"
                                    className="ewp-yellow-bg px-4 py-2 mt-3 mb-5 rounded-4 ewp-button border-0"
                                >
                                    Join us!
                                </button></a
                            >
                        </div>
                        <div className="col-sm-12 col-md-8 col-lg-9 px-0">

                            <div className="row px-0 mx-0">
                                <div
                                    className="row row-cols-1 row-cols-md-2 row-cols-sm-2 text-center m-0 px-0"
                                >
                                    <div className="col mt-md-0 mb-4 px-0 d-flex">
                                        <div className="card ewp-card rounded-4 me-sm-2">
                                            <div className="card-body px-lg-4 px-md-4 px-sm-2">
                                                <h5 className="ewp-h5 card-text ewp-text-blue text-center py-3">
                                                    User centred
                                                </h5>
                                                <p className="ewp-p text-justify ewp-why-fontsize">
                                                    Whether you’re a newcomer or a power user we keep it
                                                    simple and efficient. Unnecessary complexity adds to
                                                    cost and subtracts from results.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col mt-md-0 mb-4 px-0 d-flex">
                                        <div className="card ewp-card rounded-4 ms-sm-3">
                                            <div className="card-body px-lg-4 px-md-4 px-sm-2">
                                                <h5 className="ewp-h5 card-text ewp-text-blue text-center py-3">
                                                    Outstanding support
                                                </h5>
                                                <p className="ewp-p text-justify ewp-why-fontsize">
                                                    Our helpdesk gets a big thumbs up from 97% of the users.
                                                    We are not perfect… but we are as close as it gets.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col mt-md-0 mb-4 px-0 d-flex">
                                        <div className="card ewp-card rounded-4 me-sm-2">
                                            <div className="card-body px-lg-4 px-md-3 px-sm-2">
                                                <h5 className="ewp-h5 card-text ewp-text-blue text-center py-3">
                                                    Strategic internationalisation
                                                </h5>
                                                <p className="ewp-p text-justify ewp-why-fontsize">
                                                    Agreements and nominations are just the beginning. Our
                                                    newest features are designed to unlock in-depth insights
                                                    that will take your internationalisation game to the
                                                    next level.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col mt-md-0 mb-4 px-0 d-flex">
                                        <div className="card ewp-card rounded-4 ms-sm-3">
                                            <div className="card-body px-lg-4 px-md-4 px-sm-2">
                                                <h5 className="ewp-h5 card-text ewp-text-blue text-center py-3">
                                                    By universities, <br />for universities
                                                </h5>
                                                <p className="ewp-p text-justify ewp-why-fontsize">
                                                    The “secret sauce” of the Dashboard is that its
                                                    evolution is driven by its users. And the fact it’s
                                                    built by experts that actually know about mobility
                                                    doesn’t hurt either.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

            </main>
            <footer className="ewp-dark-blue-bg">
                <div className="container-fluid text-light pt-4 px-5">
                    <div className="row py-4">
                        <div className="col-lg-8 col-md-6">
                            <img
                                src="landing/assets/EWP-Dashboard-logo.png"
                                alt="EWP Dashboard Logo"
                                width="150"
                                height=""
                                className="d-inline-block align-text-top mb-5"
                            />
                        </div>
                        <div className="col-lg-2 col-md-3">
                            <ul className="nav flex-column ewp-nav">
                                <li className="nav-item">
                                    <a
                                        className="nav-link py-1 px-sm-0"
                                        href="/login"
                                        >Log in</a
                                    >
                                </li>
                                <li className="nav-item">
                                    <a
                                        className="nav-link py-1 px-sm-0"
                                        href="/register"
                                        >Register</a
                                    >
                                </li>
                                <li className="nav-item">
                                    <a
                                        className="nav-link py-1 px-sm-0"
                                        href="https://esci-sd.atlassian.net/servicedesk/customer/portals"
                                        >Support</a
                                    >
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-2 col-md-3">
                            <ul className="nav flex-column ewp-nav">
                                <li className="nav-item">
                                    <a
                                        className="nav-link py-1 px-sm-0"
                                        href="https://esci-sd.atlassian.net/wiki/spaces/DASH/pages/20676644/Enhanced+EWP+Dashboard"
                                        >Documentation</a
                                    >
                                </li>
                                <li className="nav-item">
                                    <a
                                        className="nav-link py-1 px-sm-0"
                                        aria-current="page"
                                        href="https://uni-foundation.eu/erasmus-without-paper/"
                                        >About EWP</a
                                    >
                                </li>
                                <li className="nav-item">
                                    <a
                                        className="nav-link py-1 px-sm-0"
                                        href="/privacy-policy-terms-conditions"
                                        >Privacy & Terms</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <p className="ewp-p mb-4">
                                * Data extracted from the EWP Stats Portal at 11 August 2025. From
                                2024/2025 DG EAC country fiches.
                            </p>
                        </div>
                    </div>
                    <div className="row pb-4">
                        <div className="col-lg-8 col-md-8">
                            <p className="ewp-p mb-sm-3 mb-md-0">
                                Funded by the European Union. Views and opinions expressed are
                                however those of the author(s) only and do not necessarily reflect
                                those of the European Union or the European Education and Culture
                                Executive Agency (EACEA). Neither the European Union nor EACEA can
                                be held responsible for them.
                            </p>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <img
                                src="landing/assets/EN_Co-fundedbytheEU_RGB_NEG.png"
                                alt="Funded by EU logo"
                                className="d-inline-block align-text-top ewp-eu-logo"
                            />
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Landing;